import { BLACK, BLACK_500, BLUE_GREY_200, BLUE_GREY_400, RED_500, LILAC_300, GREEN_500, YELLOW_500, WHITE } from '../colors';
var avatarConfig = {
  hasDot: false,
  variant: 'initials',
  initials: 'AB',
  size: 'sm',
  disabled: false,
  status: 'default',
  config: {
    size: {
      xxs: {
        avatarSize: 24,
        iconSize: 12,
        notifierSize: 'sm'
      },
      xs: {
        avatarSize: 32,
        iconSize: 16,
        notifierSize: 'sm'
      },
      sm: {
        avatarSize: 40,
        iconSize: 24,
        notifierSize: 'sm'
      },
      md: {
        avatarSize: 48,
        iconSize: 24,
        notifierSize: 'md'
      },
      lg: {
        avatarSize: 56,
        iconSize: 32,
        notifierSize: 'md'
      },
      xl: {
        avatarSize: 72,
        iconSize: 44,
        notifierSize: 'md'
      },
      xxl: {
        avatarSize: 92,
        iconSize: 44,
        notifierSize: 'md'
      }
    },
    state: {
      default: {
        backgroundColor: LILAC_300,
        color: BLACK
      },
      success: {
        backgroundColor: GREEN_500,
        color: WHITE
      },
      warning: {
        backgroundColor: YELLOW_500,
        color: BLACK
      },
      danger: {
        backgroundColor: RED_500,
        color: WHITE
      },
      disabled: {
        backgroundColor: BLACK_500,
        color: BLACK
      }
    }
  }
};
var avatarWhiteConfig = Object.assign(Object.assign({}, avatarConfig), {
  config: Object.assign(Object.assign({}, avatarConfig.config), {
    state: Object.assign(Object.assign({}, avatarConfig.config.state), {
      default: {
        backgroundColor: BLUE_GREY_200,
        color: BLACK
      },
      disabled: {
        backgroundColor: BLUE_GREY_200,
        color: BLUE_GREY_400
      }
    })
  })
});
export default {
  light: avatarConfig,
  dark: avatarConfig,
  white: avatarWhiteConfig
};